import { z } from 'zod';
import { ITEM_STATUSES, PRIORITIES, ROLES } from './enums';
/* ---- Custom fields ------------------------------------------------------ */
export const FIELD_TYPES = ['TEXT', 'NUMBER', 'CURRENCY', 'DATE', 'SELECT', 'USER', 'CHECKBOX'];
export const createFieldSchema = z.object({
    boardId: z.string().uuid().nullable().optional(),
    label: z.string().min(1).max(80).trim(),
    type: z.enum(FIELD_TYPES),
    /** SELECT needs `options`; CURRENCY takes an ISO code. */
    config: z
        .object({
        options: z.array(z.string().max(60)).max(30).optional(),
        currency: z.string().length(3).optional(),
    })
        .optional(),
});
export const setFieldValueSchema = z.object({
    itemId: z.string().uuid(),
    fieldId: z.string().uuid(),
    value: z.unknown(),
});
/* ---- Automations -------------------------------------------------------- */
export const AUTOMATION_TRIGGERS = [
    'STATUS_CHANGED',
    'OWNER_CHANGED',
    'DUE_DATE_APPROACHING',
    'ITEM_CREATED',
];
export const AUTOMATION_ACTIONS = [
    'NOTIFY_OWNER',
    'NOTIFY_USER',
    'SET_STATUS',
    'SET_PRIORITY',
    'ASSIGN_OWNER',
];
export const createAutomationSchema = z.object({
    boardId: z.string().uuid().nullable().optional(),
    name: z.string().min(1).max(140).trim(),
    trigger: z.enum(AUTOMATION_TRIGGERS),
    condition: z
        .object({
        status: z.enum(ITEM_STATUSES).optional(),
        priority: z.enum(PRIORITIES).optional(),
        withinDays: z.number().int().min(0).max(90).optional(),
    })
        .optional(),
    action: z.enum(AUTOMATION_ACTIONS),
    actionConfig: z
        .object({
        userId: z.string().uuid().optional(),
        status: z.enum(ITEM_STATUSES).optional(),
        priority: z.enum(PRIORITIES).optional(),
        message: z.string().max(300).optional(),
    })
        .optional(),
    enabled: z.boolean().default(true),
});
export const updateAutomationSchema = createAutomationSchema.partial().omit({ boardId: true });
/* ---- Scoped access ------------------------------------------------------ */
export const grantAccessSchema = z
    .object({
    userId: z.string().uuid(),
    workspaceId: z.string().uuid().nullable().optional(),
    boardId: z.string().uuid().nullable().optional(),
    role: z.enum(ROLES),
})
    .refine((v) => Boolean(v.workspaceId) !== Boolean(v.boardId), {
    message: 'Grant access to exactly one of a workspace or a board',
    path: ['boardId'],
});
//# sourceMappingURL=admin.contract.js.map